export class Prepaid {
    operator_type:string='1';
    mobile:string;
    operator:string="";
    recharge_type:string='';
    amount:string;
}
